import React, { useRef } from "react";

import PageBanner from "../../layouts/PageBanner";

import president from "../../assets/images/TheSigningOfficers/sats_president.jpg";
import ApiServer from "../../helpers/Api_help";

const Announcement = () => {
  return (
    <>
      <div className="page-content bg-white">
        <PageBanner maintitle="Home" pagetitle="PRESIDENT’S MESSAGE" />
        <section className="content-inner-2 section-wrapper5">
          <div className="container text-dark">
            <div className="row align-items-center">
              <div
                className="col-lg-12 d-flex flex-wrap justify-content-between align-items-center
              "
              >
                <div className="section-head col-lg-6 col-md-6 col-sm-12">
                  <h3>
                    வணக்கம்!
                    <br />
                  </h3>

                  <p className="m-t20 text-justify">
                    சான் அன்டோனியோ தமிழ் சங்கத்தின் (SATS) 2026–2027ஆம் ஆண்டிற்கான தலைவராக** பணியாற்றும் இந்தப் பெருமைமிகு வாய்ப்பை நான் மிகுந்த மரியாதையுடனும் நன்றியுடனும் ஏற்றுக்கொள்கிறேன். உள்ளடக்கம், ஒற்றுமை மற்றும் தமிழ்ப் பண்பாட்டுப் பெருமை ஆகிய உயரிய கொள்கைகளை அடிப்படையாகக் கொண்டு செயல்படும் நமது அமைப்பின் மீது நம்பிக்கை வைத்து, என்னையும் நமது குழுவினரையும் ஆதரித்த ஒவ்வொரு உறுப்பினர், தன்னார்வலர், முன்னாள் தலைவர் மற்றும் நலன் விரும்பிக்கும் எனது மனமார்ந்த நன்றியைத் தெரிவித்துக்கொள்கிறேன்..
                    <br /> <br />
                    என்னைப் பொறுத்தவரை, <span style={{ fontWeight: 600, color: "#000" }}>"நம்ம SATS”</span> என்பது வெறும் ஒரு அமைப்பு மட்டுமல்ல; அது நமது தாயகத்திற்கு அப்பால் அமைந்துள்ள ஒரு <span style={{ fontWeight: 600, color: "#000" }}>தாய்வீடு போன்றது</span>. தமிழ் மொழி, பண்பாடு, மரபுகள் மற்றும் சமூக விழுமியங்கள் மீதான நமது பகிரப்பட்ட அன்பால் பின்னிப்பிணைந்த ஒரு குடும்பம்.
                    <br /> <br />
                    “கருமம் செயஒருவன் கைதூவேன் என்னும் <br />
                    பெருமையின் பீடுடையது இல்” - திருக்குறள்
                    <br />
                    <br />
                    இந்தக் குறளின் கருத்து, ஒற்றுமையும் நல்லுறவும் தற்காலிகமான வேறுபாடுகளைவிட வலிமையானவை என்பதை நமக்கு நினைவூட்டுகிறது. புரிதலுடனும் பொதுவான நோக்கத்துடனும் மக்கள் ஒன்றிணையும்போது, சமூகங்கள் வலிமையடைந்து நீண்ட காலம் நிலைத்து வளர்கின்றன.
                    <br /> <br />
                    இந்தப் புதிய அத்தியாயத்தை நாம் தொடங்கும் இந்நேரத்தில், நமது நோக்கம் தெளிவானது — <span style={{ fontWeight: 600, color: "#000" }}>“நம்ம SATS”ஐ மேலும் வலிமையான, ஒன்றுபட்ட, உயிரோட்டமிக்க சமூகமாக உருவாக்குவது.</span>
                    <br /> <br />
                    அர்த்தமுள்ள பண்பாட்டு விழாக்களை உருவாக்குதல், தமிழ் கல்வியை மேலும் வலுப்படுத்துதல், இளைஞர்களின் தலைமைத்துவத்தை ஊக்குவித்தல், சமூக சேவையை விரிவுபடுத்துதல், மேலும் ஒவ்வொரு உறுப்பினரும் தங்களது பங்களிப்பு மதிப்புமிக்கது என்று உணர்ந்து, ஆர்வத்துடனும் ஊக்கத்துடனும் செயல்படக்கூடிய வாய்ப்புகளை உருவாக்குதல் ஆகியவை நமது முக்கிய நோக்கங்களாகும்.
                    <br /> <br />
                    <span style={{ fontWeight: 600, color: "#000" }}>எந்த ஒரு தலைவராலும் தனியாக வெற்றி பெற முடியாது.</span> SATS-ன் உண்மையான பலம் அதன் மக்களே — நமது தன்னார்வலர்கள், குடும்பங்கள், ஆதரவாளர்கள், முன்னாள் தலைவர்கள் மற்றும் தங்களது நேரத்தையும் அன்பையும் இந்தச் சமூகத்திற்காக அர்ப்பணிக்கும் ஒவ்வொரு உறுப்பினரும்.
                    <br /> <br />
                    ஒரே பார்வையுடனும் ஒரே நோக்கத்துடனும் நாம் ஒன்றிணைந்து, இனிய நினைவுகளை உருவாக்குவோம்; நமது மரபுகளையும் பண்பாட்டையும் பாதுகாப்போம்; வருங்கால தலைமுறைகளுக்கான ஒரு சிறந்த பாரம்பரியத்தை உருவாக்குவோம்.
                    <br /> <br />
                    **நாம் ஒன்றாக வளர்வோம்.**  <br /> 
                    **நாம் ஒன்றாகக் கொண்டாடுவோம்.**  <br /> 
                    **நாம் ஒன்றாகத் தலைமை தாங்குவோம்.**
                    <br />
                    <br />
                    அன்பும் நன்றியும் கலந்த வணக்கங்களுடன், <br />
                    <span style={{ fontWeight: 600, color: "#000" }}>
                      Dr யுவராஜ் முனியன்
                    </span>
                     <br/>
                     <span style={{ fontWeight: 600, color: "#000" }}>தலைவர்</span><br />
                     <span style={{ fontWeight: 600, color: "#000" }}>சான் அன்டோனியோ தமிழ் சங்கம் (2026–2027)</span>
                  </p>
                </div>
                <div className="col-lg-5 col-md-5 col-sm-12 ">
                  {/* <img src={president} alt="president" /> */}
                  <img
                    src={`${ApiServer}assets/committee/sats_president.jpg`}
                    alt="president"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Announcement;
